//
//
//
//
//
//
//
//
//
//
//
//
//

import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    property: {
      type: Object,
      required: true
    }
  }
}
